import React, { useMemo } from 'react'

import { studentFields } from './stuFields'
import { useProfileForm, useUser } from '../../../context'
import SectionFields from '../DynamicFields/SectionFields'
import FormResponsesSection from '../FormResponsesSection'

const StudentSection = () => {
  const { onEditionMode, userRole } = useUser()
  const { values, formActions, isNewUser } = useProfileForm()

  const isDisabled = isNewUser ? isNewUser : onEditionMode

  const fields = useMemo(
    () => studentFields({ state: values, userRole }),
    [values, userRole],
  )
  return (
    <>
      <SectionFields
        fields={fields}
        formActions={formActions}
        isDisabled={isDisabled}
      />
      {!isNewUser && (
        <FormResponsesSection
          hasForm={values.form ? true : false}
          form={typeof values.form !== 'boolean' ? values.form : undefined}
        />
      )}
    </>
  )
}

export default StudentSection
